document.querySelector('#nav-logo').addEventListener('click', function (e) {
    e.preventDefault();
    fullpage_api.moveTo(1);
});